import classNames from "classnames";
import { html, TemplateResult } from "lit-html";
import { FIRST_TAB_INDEX } from "./searchbox/new-searchbox";

export const name = "dc-tabs";
export const useShadowDOM = false;

export interface Tab<T> {
	index?: number;
	isUnavailable?: boolean;
	name: T;
	contentTemplate?: () => TemplateResult;
	tabHeaderTemplate?: () => TemplateResult;
	onClick?: () => void;
}

export interface TabProps<T> {
	data: Tab<T>[];
	selectedTab: string;
	onSelect: (tabName: T) => void;
}

export const Component = <T>(host: { dto: TabProps<T> } & { dispatchEvent: (event: Event) => void }) => {
	const props: TabProps<T> = {
		data: host.dto.data !== undefined ? host.dto.data : ([] as Tab<T>[]),
		selectedTab:
			host.dto.selectedTab && host.dto.data.some((tab) => tab.name === host.dto.selectedTab)
				? host.dto.selectedTab
				: undefined,
		onSelect: host.dto.onSelect || (() => {}),
	};

	// HELPERS

	const getVisibleTabs = (tabs: Tab<T>[]): Tab<T>[] => tabs.filter((tab) => !tab.isUnavailable);

	// COMPONENT

	return html`
		<ul class="flex select-none list-none gap-2 print:hidden">
			${getVisibleTabs(props.data).map((tab) => {
				const onClick = () => {
					props.onSelect(tab.name);
					if (typeof tab.onClick === "function") tab.onClick();
				};

				return html`
					<li class="cursor-pointer" data-tab-name=${tab.name} @click=${onClick}>
						${tab.tabHeaderTemplate() || tab.name}
					</li>
				`;
			})}
		</ul>
		<div
			class=${classNames("rounded-b-lg bg-white rounded-tr-lg", {
				"rounded-tl-none":
					getVisibleTabs(props.data).find((tab) => tab.name === props.selectedTab).index === FIRST_TAB_INDEX,
				"rounded-tl-lg":
					getVisibleTabs(props.data).find((tab) => tab.name === props.selectedTab).index !== FIRST_TAB_INDEX,
			})}
		>
			${getVisibleTabs(props.data)
				.find((tab) => tab.name === props.selectedTab)
				.contentTemplate()}
		</div>
	`;
};
